import { trackAboutUsWebsite } from '@xing-com/crate-entity-pages-common/src/tracking';

import calendarIllustration from './assets/calendar.svg';
import imprintIllustration from './assets/imprint.svg';
import websiteIllustration from './assets/website.svg';
import type { FactsItemProps } from './facts-item';
import { Imprint } from './imprint';

const linkRegEx =
  /^(https?:\/\/[\w][-äÄÉéöÖüÜß\w+&@#\/%?=~|!:,.;]*[-\w*+&@#\/%=~|]|www[-\w+&@#\/%?=~|!:,.;]*[-\w+&@#\/%=~|])\S*$/; // eslint-disable-line

export type CommonFactsItem = FactsItemProps & {
  omViewContent?: React.JSX.Element | false;
};

export function createFactsItemWebsiteUrl(
  href: string | undefined | null
): CommonFactsItem {
  if (!href) {
    return {
      type: 'websiteUrl',
      illustration: websiteIllustration,
      translationKey: 'EP_VISIT_WEBSITE_EMPTY_STATE',
      showEmptyState: true,
    };
  }

  return {
    type: 'websiteUrl',
    link: {
      href,
      target: '_blank',
      rel: 'nofollow',
    },
    trackingFunction: trackAboutUsWebsite,
    illustration: websiteIllustration,
    translationKey: 'EP_VISIT_WEBSITE',
  };
}

export function createFactsItemImprint(
  href: string | undefined | null
): CommonFactsItem {
  if (!href) {
    return {
      type: 'imprint',
      illustration: imprintIllustration,
      translationKey: 'EP_LEGAL_NOTICE_EMPTY_STATE',
      showEmptyState: true,
    };
  }

  const isUrlOnly = linkRegEx.test(href);
  return {
    type: 'imprint',
    link: isUrlOnly
      ? {
          href:
            href.includes('http://') || href.includes('https://')
              ? href
              : `http://${href}`,
          target: '_blank',
          rel: 'nofollow',
        }
      : undefined,
    omViewContent: !isUrlOnly && <Imprint imprint={href} />,
    illustration: imprintIllustration,
    translationKey: 'EP_LEGAL_NOTICE',
  };
}

export function createFactsItemFoundingYear(
  foundingYear: number | undefined | null
): CommonFactsItem {
  if (!foundingYear) {
    return {
      type: 'foundingYear',
      illustration: calendarIllustration,
      showEmptyState: true,
      translationKey: 'EP_FOUNDING_YEAR_EMPTY_STATE',
    };
  }

  return {
    type: 'foundingYear',
    illustration: calendarIllustration,
    translationKey: 'EP_FOUNDING_YEAR',
    values: { foundingYear },
  };
}
